// The host's takes in a room: when, how long, and where each stands —
// recording, uploading, being put together, or ready with its mix in Media.

import { Link } from 'react-router-dom';
import { useTakes, type Take } from '../../lib/studio/studio-api';
import { formatClock } from './Recording';

export const TAKE_LABELS: Record<string, { label: string; tone: string }> = {
  recording: { label: 'Recording', tone: 'text-danger' },
  stopped: { label: 'Uploading', tone: 'text-muted' },
  assembling: { label: 'Putting together…', tone: 'text-muted' },
  ready: { label: 'Ready', tone: 'text-success' },
  partial: { label: 'Ready, with gaps', tone: 'text-warning' },
  failed: { label: 'Failed', tone: 'text-danger' },
};

const ERRORS: Record<string, string> = {
  no_audio_recorded: 'no audio was recorded',
  nothing_recorded: 'nothing was recorded',
};

export function takeLabel(t: Pick<Take, 'status' | 'error'>): string {
  const base = TAKE_LABELS[t.status]?.label ?? t.status;
  return t.status === 'failed' && t.error ? `${base}: ${ERRORS[t.error] ?? t.error}` : base;
}

export function TakesList({ roomId }: { roomId: string }) {
  const q = useTakes(roomId);
  if (!q.data?.length) return null;
  return (
    <section aria-label="Takes" className="max-w-2xl rounded-xl border border-border p-4">
      <h2 className="text-sm font-semibold">Takes</h2>
      <ul className="mt-2 divide-y divide-border text-sm">
        {q.data.map((t) => (
          <li key={t.id} className="flex flex-wrap items-center gap-x-3 py-2">
            <span className="font-medium">Take {t.takeNumber}</span>
            <span className="text-muted">{new Date(t.startedAt).toLocaleString()}</span>
            {t.durationMs !== null && <span className="text-muted">{formatClock(t.durationMs)}</span>}
            <span className={TAKE_LABELS[t.status]?.tone ?? 'text-muted'}>{takeLabel(t)}</span>
            {t.mixMediaFileId && (
              <Link to="/media" className="ml-auto font-medium text-accent hover:underline">
                Mix in Media
              </Link>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
